import { normalizeContext } from '@/common/normalize/normalize-context'
import { snakeToCamelObj } from '@/common/converter/utils/snake-to-camel-obj'

export const normalizeBaseCatalog = (rawData) => {
  return {
    description: rawData?.description ?? '',
    version: rawData?.version ?? '',
    type: rawData?.type ?? '',
    id: rawData?.id ?? '',
    contextList: rawData?.context_list?.map(normalizeContext) ?? [],
    topContext: snakeToCamelObj(rawData?.top_context) ?? {},
  }
}
